import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ParameterViewModel } from '../../../../helper/report-helper/report-helper';

@Component({
  selector: 'app-scalp-parameter-bars',
  templateUrl: './scalp-parameter-bars.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScalpParameterBarsComponent {
  parameters = input.required<ParameterViewModel[]>();

  formatTargetRange(targetRange: string): string {
    return targetRange.replace('-', ' - ');
  }
}
